import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import Input from '../Input';
import Loader from '../Loader';
import getThemeClasses from '@oxygen/theme';
var suffixContainerClasses = "o-cpnuEd o-dsiSgT";

var getLoaderClasses = hasRightMargin => "o-lIIwF ".concat(hasRightMargin ? "o-fzpibr" : '', "");

var propTypes = process.env.NODE_ENV !== "production" ? {
  /** Custom classes for the component. */
  className: PropTypes.string,

  /** The default value of the `Input` element. */
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** If `true`, the input will be disabled. */
  disabled: PropTypes.bool,

  /** The `id` of the input element. */
  id: PropTypes.string,

  /** Custom classes for the input element. */
  inputClassName: PropTypes.string,

  /** Show / hide loading icon. */
  isLoading: PropTypes.bool,

  /** Ref to inner elements */
  innerRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.any
  })]),

  /** A custom text for label. */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Name attribute of the `input` element. */
  name: PropTypes.string,

  /** Callback fired when input is blurred. */
  onBlur: PropTypes.func,

  /** Callback fired when the value is changed. */
  onChange: PropTypes.func,

  /** Callback fired when input is focused. */
  onFocus: PropTypes.func,

  /** The short hint displayed in the input before the user enters a value. */
  placeholder: PropTypes.string,

  /** The prefix text/icon for the `Input`. */
  prefix: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Input left padding classes for the component, when prefix is passed. */
  prefixPaddingClassName: PropTypes.string,

  /** Specify an input field as read-only. */
  readOnly: PropTypes.bool,

  /** Set field as required. */
  required: PropTypes.bool,

  /** The suffix text/icon for the `Input`. */
  suffix: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** Input right padding classes for the component, when suffix is passed. */
  suffixPaddingClassName: PropTypes.string,

  /** Define input type. */
  type: PropTypes.oneOf(['text', 'number', 'tel', 'email', 'password']),

  /** The value of the `input` element. */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /** Custom width classes for the component. */
  widthClassName: PropTypes.string,

  /** Value for data testing attribute. */
  'data-testing-id': PropTypes.string
} : {};
var defaultProps = {
  isLoading: false,
  className: '',
  inputClassName: ''
};

var InputWithLoader = props => {
  var {
    isLoading,
    suffix
  } = props,
      otherProps = _objectWithoutProperties(props, ["isLoading", "suffix"]);

  var hasSuffix = isLoading && suffix;
  var Container = hasSuffix ? 'div' : React.Fragment;

  var renderSuffix = () => {
    var containerClasses = hasSuffix ? suffixContainerClasses : '';
    return React.createElement(Container, {
      className: containerClasses
    }, isLoading ? React.createElement(Loader, {
      className: getLoaderClasses(suffix)
    }) : null, suffix);
  };

  return React.createElement(Input, _extends({
    suffix: renderSuffix()
  }, otherProps));
};

InputWithLoader.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
InputWithLoader.defaultProps = defaultProps;
export default InputWithLoader;